import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transactions-tabs',
  templateUrl: './transactions-tabs.component.html',
  styleUrls: ['./transactions-tabs.component.scss']
})
export class TransactionsTabsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
